var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLifeAndPeopleNightlife(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-2352.000000, -772.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Life-and-people/Nightlife",
    transform: "translate(2352.000000, 772.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5379489,5.99748226 C24.1947869,5.99748226 25.5380878,7.3359427 25.5420947,8.9892762 L25.5420947,8.9892762 L25.5430964,8.9892762 C25.5420947,8.99227499 25.5430964,8.99427418 25.5430964,8.99627338 L25.5430964,8.99627338 L25.5370861,8.99627338 L16.0267959,21.0923971 L16.0267959,30.0008059 L19.1641699,30.0008059 C20.2650556,30.0008059 21.1676016,30.9014429 21.1676016,32 L21.1676016,32 L7.88084267,32 C7.88084267,30.9014429 8.78238693,30.0008059 9.88427435,30.0008059 L9.88427435,30.0008059 L13.0216484,30.0008059 L13.0216484,21.0923971 L3.51035645,8.99627338 L3.50534787,8.99627338 L3.50534787,8.9892762 L3.51085535,8.81338482 C3.605706,7.2420456 4.91186424,5.99748226 6.5104954,5.99748226 L6.5104954,5.99748226 Z M9.15502522,9.18819601 C8.47285673,8.31654739 7.21369992,8.15661187 6.33519512,8.83233946 L6.33519512,8.83233946 L10.2529058,13.8373218 C10.9350743,14.7089704 12.1952328,14.868906 13.0737376,14.194178 L13.0737376,14.194178 Z M22.4845574,0 C27.4640869,0 31.5,4.02737646 31.5,8.99637334 L31.5,8.99637334 L27.5462276,8.99637334 L27.5462276,8.98237898 C27.5462276,6.22648995 25.2993789,3.98439379 22.5376484,3.98439379 L22.5376484,3.98439379 L22.4845574,3.98439379 Z M5.97337536,0.0129947615 L9.34014231,3.98439379 L6.7156468,3.98439379 L5.04378306,2.01218884 L0.5,2.01218884 L0.5,0.0129947615 L5.97337536,0.0129947615 Z",
    id: 50
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeAndPeopleNightlife);
export default __webpack_public_path__ + "static/media/life-and-people-nightlife.4bf96d5e.svg";
export { ForwardRef as ReactComponent };